// extracted by mini-css-extract-plugin
module.exports = {"center":"center-module--center--EiIKc","videoContainer":"center-module--videoContainer--180gu"};